import React from 'react';
import SEO from '../seo/SEO';
import Hero from '../components/Hero';
import WeddingPhotographersSection from '../components/WeddingPhotographersSection';
import DetailsSection from '../components/DetailsSection';
import LightCrafterSection from '../components/LightCrafterSection';
import StylizedShootSection from '../components/StylizedShootSection';
import WeddingExperienceSection from '../components/WeddingExperienceSection';
import ContactSection from '../components/ContactSection';
import { useLanguage } from '../contexts/LanguageContext';

const HomePage = () => {
  const { lang } = useLanguage();
  const title = lang === 'fr'
    ? 'Lino Ludovic – Photographe & Vidéaste de mariage'
    : 'Lino Ludovic – Wedding Photographer & Videographer';
  const description = lang === 'fr'
    ? 'Photographie éditoriale et films cinématographiques en France et dans le monde. Récit intemporel avec sensibilité et élégance.'
    : 'Editorial wedding photography and cinematic films in France and worldwide. Timeless storytelling with sensitivity and elegance.';

  const h1VisuallyHiddenStyle = {
    position: 'absolute',
    width: '1px',
    height: '1px',
    padding: 0,
    margin: '-1px',
    overflow: 'hidden',
    clip: 'rect(0, 0, 0, 0)',
    whiteSpace: 'nowrap',
    border: 0
  };
  return (
    <>
      <SEO
        title={title}
        description={description}
        image="/images/HOMEFULLPAGE.jpg"
        type="website"
        schema={{
          '@context': 'https://schema.org',
          '@type': 'WebPage',
          name: 'Home'
        }}
      />
      <div id="home">
        <h1 style={h1VisuallyHiddenStyle}>{title}</h1>
        <Hero />
      </div>
      <WeddingPhotographersSection />
      <DetailsSection />
      <div id="experience"><WeddingExperienceSection /></div>
      <div id="about"><LightCrafterSection /></div>
      <div id="portfolio"><StylizedShootSection /></div>
      <div id="contact"><ContactSection /></div>
    </>
  );
};

export default HomePage;
